import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Services = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Run once to ensure it's accurate even after initial render
    handleResize();

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  if (isMobile) {
    return (
      <div className="mobile-service-page-body-wrapper">
        <div className="mobile-service-page-hero-text-wrapper">
          <div className="mobile-service-page-hero-text">Services</div>
        </div>
        <div className="mobile-service-page-services-cards-wrapper">
          <div className="mobile-service-page-services-card-wrapper">
            <div className="mobile-service-page-services-text">
              Tax Advisory
            </div>
            <div className="mobile-service-page-services-img-wrapper">
              <Link to="/services/tax-advisory">
                <img
                  className="mobile-service-page-services"
                  src=""
                  alt="service"
                />
              </Link>
            </div>
          </div>
          <div className="mobile-service-page-services-card-wrapper">
            <div className="mobile-service-page-services-text">Service</div>
            <div className="mobile-service-page-services-img-wrapper">
              <Link to="/services/risk-advisory">
                <img
                  className="mobile-service-page-services"
                  src=""
                  alt="service"
                />
              </Link>
            </div>
          </div>
          <div className="mobile-service-page-services-card-wrapper">
            <div className="mobile-service-page-services-text">Service</div>
            <div className="mobile-service-page-services-img-wrapper">
              <Link to="/services/mergers-acquisitions">
                <img
                  className="mobile-service-page-services"
                  src=""
                  alt="service"
                />
              </Link>
            </div>
          </div>
          <div className="mobile-service-page-services-card-wrapper">
            <div className="mobile-service-page-services-text">Service</div>
            <div className="mobile-service-page-services-img-wrapper">
              <Link to="/services/audit-assurance">
                <img
                  className="mobile-service-page-services"
                  src=""
                  alt="service"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="service-page-body-wrapper">
      <div className="service-page-hero-text-wrapper">
        <div className="service-page-hero-text">Services</div>
      </div>
      <div className="service-page-services-cards-wrapper">
        <div className="service-page-services-card-wrapper">
          <div className="service-page-services-text">Tax Advisory</div>
          <div className="service-page-services-img-wrapper">
            <Link to="/services/tax-advisory">
              <img className="service-page-services" src="" alt="service" />
            </Link>
          </div>
        </div>
        <div className="service-page-services-card-wrapper">
          <div className="service-page-services-text">Risk Advisory</div>
          <div className="service-page-services-img-wrapper">
            <Link to="/services/risk-advisory">
              <img className="service-page-services" src="" alt="service" />
            </Link>
          </div>
        </div>
      </div>
      <div className="service-page-services-cards-wrapper">
        <div className="service-page-services-card-wrapper">
          <div className="service-page-services-text">Mergers & Acquisitions</div>
          <div className="service-page-services-img-wrapper">
            <Link to="/services/mergers-acquisitions">
              <img className="service-page-services" src="" alt="service" />
            </Link></div>
        </div>
        <div className="service-page-services-card-wrapper">
          <div className="service-page-services-text">Audit & Assurance</div>
          <div className="service-page-services-img-wrapper">
            <Link to="/services/audit-assurance">
              <img className="service-page-services" src="" alt="service" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
